import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const TexasStarNinja = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'texas-star');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default TexasStarNinja;
